














































import { Component, Prop, Vue } from 'vue-property-decorator';

import { swiper, swiperSlide } from 'vue-awesome-swiper';
import 'swiper/dist/css/swiper.css';
import 'animate.css';
import SwiperAnimation from 'swiper-animation';
import {
  TimelineMax,
  CSSPlugin,
  ScrollToPlugin,
  Draggable,
  Power4,
  Expo,
  Elastic,
  Bounce,
  onComplete,
  clearProps,
  TweenMax,
  fromTo
} from 'gsap/all';
import { HOST } from '@/global';
const swiperAnimation: any = new SwiperAnimation();
@Component({
  name: 'NewBanner',
  components: {
    swiper,
    swiperSlide
  }
})
export default class NewBanner extends Vue {
  @Prop() compData: any;
  HOST = HOST;

  swiperOption: any = {
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    fadeEffect: { crossFade: true },
    speed: 800,
    mousewheelControl: true,
    touchRatio: 0,
    effect: 'fade',
    autoplay: {
      delay: 5000
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    on: {
      init: function() {
        // console.log(this)
        console.log(swiperAnimation.init());
        swiperAnimation.init(this).animate();
      },
      slideChange: function() {
        swiperAnimation.init(this).animate();
      }
    }
  };

  public bannerContent() {
    const tl = new TimelineMax({
      delay: 1
    });
    tl.fromTo(
      '.overlay-div',
      2,
      { yPercent: 0 },
      {
        yPercent: -100,
        ease: Expo.easeInOut,
        onComplete: function() {
          TweenMax.set('.overlay-div', { display: 'none' });
        }
      }
    )
      .fromTo(
        '.banner-img',
        2,
        { scale: 0.83 },
        {
          scale: 1,
          ease: Expo.easeInOut,
          clearProps: 'all'
        },
        '-=1.2'
      )
      .fromTo(
        '.slider-content,.swiper-pagination',
        1,
        { opacity: 0 },
        {
          opacity: 1,
          ease: Expo.easeOut,
          clearProps: 'all'
        },
        '-=1.1'
      );
  }

  public mounted() {
    this.bannerContent();
  }
}
